import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { generateQueryParametersFromLocation } from 'src/utils';

export const getPaginationStateFromLocation = (
  locationState,
  initialPage = 0,
  initialRowsPerPage = 10
) => {
  const { rows = initialRowsPerPage, page = initialPage } = locationState || {};
  return {
    initialRowsPerPage: rows,
    initialPage: page,
  };
};

const usePaginationHook = ({
  initialPage = 0,
  initialRowsPerPage = 10,
  shouldModifyRoute,
} = {}) => {
  const history = useHistory();
  const location = useLocation();

  const [page, setPage] = React.useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = React.useState(initialRowsPerPage);

  const onPageChange = (event, newPage) => {
    const value = parseInt(newPage, 10);
    if (shouldModifyRoute) {
      history.push(
        {
          pathname: location.pathname,
          search: generateQueryParametersFromLocation(location, { page: value }),
        },
        { ...location.state, page: value }
      );
    } else {
      setPage(value);
    }
  };

  const onRowsPerPageChange = event => {
    const rows = parseInt(event.target.value, 10);
    if (shouldModifyRoute) {
      history.push(
        {
          pathname: location.pathname,
          search: generateQueryParametersFromLocation(location, { page: 0, rows }),
        },
        { ...location.state, rows, page: 0 }
      );
    } else {
      setRowsPerPage(rows);
      setPage(0);
    }
  };

  useEffect(() => {
    if (shouldModifyRoute) {
      const { rows, page: locationPage } = location.state || {};
      setPage(parseInt(locationPage || '0', 10));
      setRowsPerPage(parseInt(rows || '10', 10));
    }
  }, [location.state, shouldModifyRoute]);

  return {
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
  };
};

export { usePaginationHook };
